module.exports = __webpack_public_path__ + "static/media/aroldo-mostrandoabaixo-esquerda.52a7c60c.svg";